export const setAppliedFilterHandler = (state, action) => {
  state.appliedFilter = JSON.parse(JSON.stringify(action.payload));
};

export const setFilterObjectHandler = (state, action) => {
  state.filterObject = action.payload;
};

export const setFilterLoaderHandler = (state, action) => {
  state.filterLoader = action.payload;
};

export const setShipmentsCachingData = (state, action) => {
  state.shipmentsCaching = action.payload;
};

export const setImporterCachingData = (state, action) => {
  state.importerCaching = action.payload;
};

export const setExporterCachingData = (state, action) => {
  state.exporterCaching = action.payload;
};

export const setLogisticsCachingData = (state, action) => {
  state.logisticsCaching = action.payload;
};

export const setAnalyticsCachingData = (state, action) => {
  state.analyticsCaching = action.payload;
};

export const setFilterMustNotHandler = (state, action) => {
  state.filterMustNot = action.payload;
};

export const setSelectedFilterListHandler = (state, action) => {
  state.selectedFilterList = action.payload;
};

export const setSearchParameters = (state, action) => {
  state.searchParameters = action.payload;
};

export const setDateParameters = (state, action) => {
  state.dateParameters = action.payload;
};

export const setPlanDetailsHandler = (state, action) => {
  state.planDetails = action.payload;
};
